var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,228)",
    d: "m0 0 1 3-15 33-20 41-11 22-10 18-21 14-1 2 17-3h3l-2 5-7 14h6l6 4 4 13 9 42v4h18l6 3 4 5 22 65 14 41 18 53 15 43 18 52 7 20-1 8-5 4-52 6-233 26-10 9-13 6-11 3-16 1-17-3-12-5-11-8-4-3-81-9-210-22-10-2-4-4v-7l15-44 15-43 15-44 15-43 15-44 15-43 7-20 7-6h15l3 1 2-12 11-46 3-6 5-4h13l29 6 27 8 27 10 26 12 23 12 19 11 17 11 17 12 4 3v-155l-14 18-10 12-6 1-5-3-1-6 6-9 13-16 10-13 8-10 4-3h6l7 6 10 13 11 14 13 16 2 4-1 6-3 3h-6l-6-5-11-14-10-13v151l30-20 33-21 7-5 26-44 16-24 10-14 11-14 14-15 13-12 12-9 21-14 26-15 20-11z",
    fill: "#306EC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,385)",
    d: "m0 0 10 1 30 7 30 10 22 9 25 12 19 10 25 15 21 14 12 9 1 1v241l-5-3-19-14-17-12-26-17-10-6-21-12-23-12-16-7-15-7-18-7-45-15-29-8 1-8 17-71 13-55 10-43 6-24z",
    fill: "#ADE4FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,382)",
    d: "m0 0h1l3 18 19 86 8 35 7 31 10 43-1 3-20 6-26 9-29 11-33 15-23 12-20 12-13 8-12 8-29 20-16 12-5 3v-244l27-18 22-14 6-4 2 1-5 10-7 19-6 24-6 33-2 18v7l5-3 5-12 15-40 11-26 12-26 13-26 6-10 1 2-17 33-14 30-11 27-13 35-13 40-6 22-14 55 1 4h5l13-11 9-42 6-26 5-3 22-13 11-9 12-12 12-13 8-11 6-7 8-14 7-21 1-5-9 8-15 6-5 1v-2l12-5 16-13 13-13 7-11 16-34 6-14z",
    fill: "#AEE4FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,228)",
    d: "m0 0 1 3-15 33-20 41-11 22-10 18-21 14-1 2 17-3h3l-2 5-7 14h-2l-1 10-15 33-9 19-8 10-14 14-15 11-10 3 1 1 15-5 9-6 5-4-4 16-6 15-9 14-8 9-6 8-11 12-14 14-13 9-17 10-4 2-6 26-9 42-10 9-4 3h-5l-2-2 2-11 13-52 7-23 14-43 16-41 12-27 12-25 12-23-8 14-15 30-14 32-16 42-7 18-3 4-5 2 1-18 4-26 7-32 6-18 7-17 7-15 10-19 15-25 10-17 16-24 10-14 11-14 14-15 13-12 12-9 21-14 26-15 20-11z",
    fill: "#72C0EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,457)",
    d: "m0 0h9l3 4 12 36 15 46 24 72 13 38 14 43 1 4-58 3-46 4-47 6-47 8-45 10-34 9-5 1 3-3 13-5 14-6 17-7 36-12 23-7 28-7 35-7 37-6 32-4 4-1v-9l-6-23-7-24-18-71-13-57-7-31z",
    fill: "#B3E6FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,452)",
    d: "m0 0h9l-2 10-18 73-18 72-5 19-11 42v5l5 3 50 6 37 6 35 7 34 9 36 12 16 6 25 10 11 5 4 2-3 1-9-3-41-10-44-9-52-8-47-5-44-3-44-2-6-1 2-10 12-36 17-52 12-36 14-41 9-27 13-37z",
    fill: "#B3E6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,627)",
    d: "m0 0 8 1 26 6 36 10 35 11 29 11 18 8 24 12 20 12 22 14 19 13 12 9 4 4-10-3-45-19-30-11-24-8-29-8-43-9-45-7-34-4-4-1 1-7 8-30z",
    fill: "#B1E5FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,632)",
    d: "m0 0h2l7 24 3 14-34 4-40 7-37 8-27 7-36 12-18 7-16 6-11 5-15 6-12 6-2-1 14-10 17-12 20-12 13-8 22-12 21-10 19-8 17-6 30-10 34-10z",
    fill: "#B2E5FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,266)",
    d: "m0 0v3l-11 13-11 14-14 18-13 18-24 36-16 27-10 18-11 21-16 36-15 38-14 43-6 20-2 7-8 33-6 29-10 9-4 3h-5l-2-2 2-11 13-52 7-23 14-43 16-41 12-27 12-25 13-25 15-25 22-33 14-19 12-14 7-8 22-22 8-7z",
    fill: "#306EC1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,182)",
    d: "m0 0h7l5 5 13 16 30 39v7l-3 3h-7l-6-5-12-16-14-17-9-12h-2l-9 12-14 18-11 14-6 7-2 1h-6l-4-4v-6l10-13 33-42 5-6z",
    fill: "#306EC1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,711)",
    d: "m0 0h17l41 2 59 5 55 7 41 7 34 7 29 7v1l-12-1-176-19-90-10z",
    fill: "#71C0EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,711)",
    d: "m0 0h5l2 5-1 1-153 18-81 9-30 3 2-2 38-9 42-8 47-7 44-5 38-3z",
    fill: "#71C0EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,224)",
    d: "m0 0 4 1v9h10l1 5-1 2h-10v35l-4 8-9 7-14 8-5 5-1 3-1 45-5 10-9 6-25 12-15 8-6 1-2-4 3-3 16-8 27-13 5-3 3-5 1-42 2-9 8-9 20-12 3-4 1-3 1-33h-10l-1-1v-5l1-1h10v-9z",
    fill: "#71C0EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,485)",
    d: "m0 0h6l26 10 41 16 41 18 22 12 11 7 1 5-3 3-5-1-18-10-28-14-38-16-53-21-4-3z",
    fill: "#71C0EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,242)",
    d: "m0 0h5l10 13 3 6-2 2-5-1-2-3v53l3 6 13 8 9 6 4 5 2 9 1 15 4 6 31 16 1 4-2 2-6-1-19-10-10-6-5-6-2-6-1-17-3-6-14-8-8-6-4-6-2-7-1-55-7 8-5-1 1-6z",
    fill: "#72C0EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,555)",
    d: "m0 0 6 1 27 10 40 18 29 15 9 6 1 1v6l-2 2-6-1-36-18-34-15-31-13-5-3-1-4z",
    fill: "#71C0EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,559)",
    d: "m0 0h7l1 7-8 4-42 15-20 9-16 8-21 11-15 8h-5l-2-2 1-4 8-6 23-13 21-11 25-11 34-12z",
    fill: "#71C0EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,429)",
    d: "m0 0 8 1 36 14 28 12 29 14 19 10 3 3-1 4-2 2-5-1-30-15-49-21-26-11-12-4-1-5z",
    fill: "#71C0EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(312,510)",
    d: "m0 0 8 1 31 12 30 12 22 10 2 3-1 5-5 2-64-27-22-9-2-2v-6z",
    fill: "#71C0EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,531)",
    d: "m0 0 6 1 2 4-6 4-42 15-36 15-8 3-4-1-1-1v-6l16-8 25-10 28-10z",
    fill: "#71C0EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,711)",
    d: "m0 0h17l41 2 59 5 55 7 41 7 34 7 29 7v1l-12-1-176-19-90-10zm1 2-1 2 2 1 221 24 20 2h7v-1l-56-11-40-6-42-5-48-4-40-2z",
    fill: "#9EDBF9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,711)",
    d: "m0 0h5l2 5-1 1-153 18-81 9-30 3 2-2 38-9 42-8 47-7 16-1-4 2-49 7-40 7-27 6 125-14 75-9 38-4v-2l-59 3-57 5 1-2 35-4 45-3z",
    fill: "#9EDBF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,458)",
    d: "m0 0 8 1 29 12 23 10 8 5-1 5-1 1-7-1-58-24-2-2v-6z",
    fill: "#71C0EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,747)",
    d: "m0 0 8 5 12 3h32l11-3 3-3 2 1-3 6-7 6-12 4h-22l-10-3-8-4-5-6z",
    fill: "#ACE2FA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,165)",
    d: "m0 0h6v11h9l2 1v5l-1 1h-10v14l-5 1-1-1v-14h-9l-2-2 1-4 1-1h9z",
    fill: "#71C0EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,296)",
    d: "m0 0 4 1 1 1v11h10l1 5-1 1h-10v13l-5 1-2-4v-9l-9-1-1-5 1-1h9v-11z",
    fill: "#72C1EF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,539)",
    d: "m0 0 12 3 18 6 3 3-2 5-1 1-9-1-22-7-2-2 1-7z",
    fill: "#71C0EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,205)",
    d: "m0 0h6l4 4v7l-3 4-5 1-5-2-2-3v-6z",
    fill: "#71C0EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,711)",
    d: "m0 0h17l41 2 19 2v1h-13l-40-2h-23l1 1 17 2v2l-21-2z",
    fill: "#9EDBF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,735)",
    d: "m0 0h2v2l-23 5 1 2-14 2-11 1 2-2 38-9z",
    fill: "#9BD9F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,711)",
    d: "m0 0h17l7 1v1l-23 1 1 1 17 2v2l-21-2z",
    fill: "#9AD9F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,741)",
    d: "m0 0 10 1 16 4v1l-12-1-12-2-2-1z",
    fill: "#9AD9F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,724)",
    d: "m0 0 2 1-3 3v3l-15 7-2-1 14-10z",
    fill: "#D4EFFB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,732)",
    d: "m0 0 3 1h-2l1 3-18 5-2-1 9-4z",
    fill: "#CAEAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,733)",
    d: "m0 0 6 1 11 5-3 1-15-5z",
    fill: "#E0F3FC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,714)",
    d: "m0 0h2l-1 3-7 1h-8l2-2 10-1z",
    fill: "#9CDAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fe2a84fb0800b9e0e9545b61a21fe366.svg";
export { ForwardRef as ReactComponent };